import {ErrorMessage, Field, FieldArray, Form, Formik} from "formik";
import * as Yup from "yup";
import {DeleteOutline, Edit, NavigateBefore, NavigateNext, Schedule} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import {getBlogs, getProducts, url} from "../services/service";
import axios from "axios";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import {environmentSelector, userinfoSelector} from "../slices/UserSlice";
import {useNavigate} from "react-router-dom";
import {Spinner, BlogsTable} from "../components";
import ReactQuill from "react-quill";


const Product = () => {
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ size: ["small", false, "large", "huge"] }],

            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],

            [{ script: "sub" }, { script: "super" }],

            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],

            [{ align: [] }],

            ["blockquote", "code-block"],

            ["link", "image", "video"],

            ["clean"],
        ],
    };

    const dataneeded = useSelector(userinfoSelector)
    const status = useSelector((state) => state.userinfo.status)
    const [data, setdata] = useState(false)
    const [image, setImg] = useState('')
    const [image2, setImg2] = useState('')
    const [image3, setImg3] = useState('')

    const nav = useNavigate()
    const [value, setValue] = useState('');

    // pending
    const [pending, setPending] = useState(false)


    // filtering search
    const [search, setSearch] = useState('')


    const env = useSelector(environmentSelector)


    const getData = async (page) => {
        const config = {
            headers: {
                Authorization: `Bearer ${dataneeded.user.token}`
            },
            params: {
                take: 8, page: page, search: search
            }
        }


        const response = await getProducts(config)


        if (response) {

            if (response.data.code === 1) {

                setdata(response.data)
                console.log(response)

            } else {
                toast.error(response.data.error)
            }

        } else {
            toast.error('اتصال خود به شبکه را بررسی کرده و مجددا تلاش کنید.')
        }
    }


    useEffect(() => {
        if (status !== 'done') {
            nav('/');
            toast.error('ابتدا وارد سیستم شو🤔')
        } else {
            getData().then()
        }
    }, [search]);


    const handleAdd = async (values, value) => {



        const config = {
            headers: {
                Authorization: `Bearer ${dataneeded.user.token}`
            }
        }
        const conf = window.confirm('آیا  مطمن هستید ؟')
        if (conf) {
            const endpoint = `${url}/admin/product/add`


            const formdata = new FormData()
            formdata.append("title", values.title)
            formdata.append("attributes",JSON.stringify(values.attributes) )
            formdata.append("price", values.price)
            formdata.append("description", values.description)
            formdata.append("image1", image)
            formdata.append("image2", image2)
            formdata.append("image3", image3)
            setPending(true)
            toast.info('در حال ارسال ...')
            const response = await axios.post(endpoint, formdata, config)
            if (response) {
                toast.dismiss()
                if (response.data.code === 1) {

                    toast.success('با موفقیت اضافه شد.');
                    setPending(false)
                    setdata(false)
                    getData().then();
                } else {
                    toast.warning(response.data.error)
                }
            } else {
                toast.error('اتصال خود را بررسی کنید')
            }


        }

    }

    const handleDelete = async (itemid) => {
        const config = {
            headers: {
                Authorization: `Bearer ${dataneeded.user.token}`
            }
        }
        const conf = window.confirm('آیا از حذف مطمن هستید ؟')
        if (conf) {

            let endpoint = `${url}/admin/product/delete/${itemid}`

            const response = await axios.get(endpoint, config)
            if (response) {
                if (response.data.code === 1) {
                    toast.success('با موفقیت حذف شد.');
                    getData().then();
                } else {
                    toast.warning(response.data.error)
                }
            } else {
                toast.error('اتصال خود را بررسی کنید')
            }
        }

    }


    let content
    if (data !== false) {
        content = <BlogsTable>

            {data.items.map((item) => {
                return (
                    <>
                        <tr key={item.id} className='has-text-centered yekan'>


                            <td>{item.date_text}</td>
                            <td>{item.title}</td>


                            <td>

                                <button className='button is-danger is-outlined mx-1'
                                        onClick={() => handleDelete(item.id)}>
                                    <DeleteOutline/>
                                </button>

                                {/*<button className='button is-link is-outlined mx-1'*/}
                                {/*        onClick={() => nav(`/admin/blogs/${item.id}`)}>*/}
                                {/*    <Edit/>*/}
                                {/*</button>*/}


                            </td>
                        </tr>
                    </>

                )
            })}
        </BlogsTable>
    } else {
        content = <div className='column is-12'>
            <Spinner/>
        </div>
    }
    return (
        <>
            <div className='columns is-variable is-3 mt-3 p-6  is-multiline '>
                <div className='column is-12 welcome__master '>
                    <h1 className='has-text-centered pinar is-size-4 clrtwotext has-text-weight-bold'>
                      اضافه کردن محصول


                    </h1>

                    <article className='subtitle yekan my-3 is-size-6'>
                      مشاهده اضافه و ویرایش محصولات
                    </article>

                </div>


                <div className='column is-12 welcome__master my-2'>


                    <h3 className='yekan'>
                        اضافه کردن محصول
                    </h3>

                    <Formik initialValues={{
                        title: '',
                        description:'',
                        price:'',
                        attributes: [
                            {
                                key: "",
                                value: ""
                            }
                        ]


                    }} validationSchema={Yup.object().shape({

                        title: Yup.string().required('ضروری').max(2000, 'باید کمتر از 2000 کاراکتر باشد'),


                    })} onSubmit={(values, actions) => {
                        handleAdd(values, value);
                        actions.resetForm();
                    }}>
                        {({values,errors, touched}) => (
                            <Form className=''>


                                <label className='label mt-3 yekan' aria-hidden="true">عنوان محصول</label>
                                <Field className='yekan input my-2' type="text" id="title" name="title"/>
                                <ErrorMessage component='span' className='has-text-danger yekan mx-auto' name='title'/>


                                <label className='label mt-3 yekan' aria-hidden="true">متن توصیفی</label>
                                <Field className='yekan input my-2 textarea' type="text"  id="description" name="description"/>

                                <label className='label mt-3 yekan' aria-hidden="true">قیمت </label>
                                <Field className='yekan input my-2 ' type="number"  id="price" name="price"/>


                                <label className='label mt-3 yekan' aria-hidden="true"> عکس اصلی </label>
                                <input onChange={(e) => setImg(e.target.files[0])} className='yekan input'
                                       type='file' id="img"
                                       name="img"/>


                                <label className='label mt-3 yekan' aria-hidden="true"> عکس انتخابی </label>


                                {

                                    image !== '' ?


                                        <div className='has-text-centered'>
                                            <img src={URL.createObjectURL(image)} alt=""
                                                 style={{maxWidth: '20rem'}}/>
                                        </div>


                                        :
                                        <p className='has-text-centered'>
                                            تصویری انتخاب کنید.
                                        </p>
                                }

                                <label className='label mt-3 yekan' aria-hidden="true"> عکس دوم </label>
                                <input onChange={(e) => setImg2(e.target.files[0])} className='yekan input'
                                       type='file' id="img2"
                                       name="img2"/>

                                {

                                    image2 !== '' ?


                                        <div className='has-text-centered'>
                                            <img src={URL.createObjectURL(image2)} alt=""
                                                 style={{maxWidth: '20rem'}}/>
                                        </div>


                                        :
                                        <p className='has-text-centered'>
                                            تصویری انتخاب کنید.
                                        </p>
                                }


                                <label className='label mt-3 yekan' aria-hidden="true"> عکس سوم </label>
                                <input onChange={(e) => setImg3(e.target.files[0])} className='yekan input'
                                       type='file' id="img3"
                                       name="img4"/>

                                {

                                    image3 !== '' ?


                                        <div className='has-text-centered'>
                                            <img src={URL.createObjectURL(image3)} alt=""
                                                 style={{maxWidth: '20rem'}}/>
                                        </div>


                                        :
                                        <p className='has-text-centered'>
                                            تصویری انتخاب کنید.
                                        </p>
                                }

                                <p className='ئف-3'>
                                  جدول ویزگی های فنی
                                </p>
                                <FieldArray name="attributes">
                                    {({ push, remove }) => (
                                        <>
                                            {values.attributes.map((attribute, index) => (
                                                <div key={index}>

                                                    <Field
                                                        name={`attributes.${index}.key`}
                                                        placeholder="نام ویژگی"
                                                    />

                                                    <Field
                                                        name={`attributes.${index}.value`}
                                                        placeholder="مقدار "
                                                    />

                                                    <button
                                                        className='button is-danger'
                                                        type="button"
                                                        onClick={() => remove(index)}
                                                    >
                                                        حذف
                                                    </button>

                                                </div>
                                            ))}

                                            <p
                                                className='button is-success'
                                                type="button "
                                                onClick={() => push({ key: "", value: "" })}
                                            >
                                               اضافه
                                            </p>
                                        </>
                                    )}
                                </FieldArray>


                                <div className='has-text-centered py-6'>
                                    {
                                        pending ? <Spinner/> : <button
                                            className='button clrone has-text-weight-bold  pinar mt-6 mx-3 borderrad1 '
                                            type='submit'> اضافه کن
                                        </button>
                                    }


                                </div>


                            </Form>


                        )}


                    </Formik>
                </div>

                <div className='column is-12 my-2 welcome__master'>
                    <input className="input" onChange={(e) => setSearch(e.target.value)} type="text"
                           placeholder="جستجو ..."/>
                </div>


                {
                    content
                }


                {/*paginator*/}
                <div className='column is-12'>
                    {data &&
                        <div className='pinar' style={{display: 'flex', justifyContent: 'center'}}>


                            {/*before page with tick*/}
                            {
                                data.paginator.beforePage < data.paginator.currentPage && (

                                    <button onClick={() => getData(data.paginator.beforePage)} className='button'>
                                        <NavigateNext/>
                                    </button>
                                )


                            }


                            {/*map beforePages*/}
                            {data.paginator.beforePages.length > 0 &&

                                <>
                                    {data.paginator.beforePages.map((item, index) =>
                                        <button className='button' onClick={() => getData(item)} key={index}>
                                            {item}
                                        </button>
                                    )}
                                </>

                            }


                            {/*active*/}

                            {
                                data.paginator.total > 0 &&
                                <button className='clrtwo has-text-white button'>{data.paginator.currentPage}</button>


                            }


                            {/*map nextPages*/}
                            {data.paginator.nextPages.length > 0 &&
                                <>
                                    {data.paginator.nextPages.map((item, index) =>
                                        <button className='button' onClick={() => getData(item)} key={index}>
                                            {item}
                                        </button>
                                    )}
                                </>

                            }


                            {/*next page with tick*/}
                            {

                                data.paginator.nextPage > data.paginator.currentPage && (

                                    <button onClick={() => getData(data.paginator.nextPage)}
                                            className='button is-transparent'>
                                        <NavigateBefore/>
                                    </button>
                                )


                            }


                        </div>
                    }
                </div>

                <div className='column is-12'>

                </div>

            </div>


        </>
    )
}
export default Product;